export default "__VITE_ASSET__B9N5XeVy__"